import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { actions } from "../../../../store/modules";
import i18n from "../../../../plugins/i18n/i18n";
import moment from "moment";
import parsePhoneNumber from 'libphonenumber-js'
import { Col, Row, Spin, notification as Notification, PageHeader, Button, Skeleton, Collapse, Modal, Popover } from 'antd';
import { EditOutlined, DeleteOutlined, FieldTimeOutlined, CheckCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { errorMessageNotification, isMobile } from "../../../../helpers";
import TripApproverView from './TripApproverView';
import Direction from '../../components/GoogleMaps/Direction';


const { confirm } = Modal;
const { Panel } = Collapse;

class TripDetail extends Component {

    constructor(props) {
        super(props);
        this.endpoint = { keyOne: "trip", idOne: this.props.match.params.id };
        this.state = {
            data: null,
            histories: [],
            loadings: {
                data: false
            },
            updateOptions: null,
            isError: false,
        };
        this.initMap = this.initMap.bind(this);

    }

    componentWillMount() {
        if (isMobile()) {
            this.setState({
                isResponsive: true,
            });
        }


        this.getData();
        this.updateOptions();
        this.fetchUpdateHistory();

    }

    showCancelConfirm = () => {

        let { loadings } = this.state;

        let _this = this;

        confirm({
            title: 'Uyarı',
            icon: <ExclamationCircleOutlined />,
            content: 'Talebinizi iptal etmek istediğinize emin misiniz?',
            okText: 'Evet',
            okType: 'danger',
            cancelText: 'İptal',
            confirmLoading: loadings.cancel,
            onOk() {
                _this.fetchCancel()
            },
            onCancel() {
            },
        });
    };


    fetchCancel = () => {

        let endpoint = { keyOne: "trip", idOne: this.props.match.params.id, keyTwo: "cancel" };

        let { loadings } = this.state;

        loadings.cancel = true;
        this.setState({ loadings });

        this.props
            .dispatch(
                actions.definitions.addData({
                    ...endpoint,
                })
            )
            .then((response) => {

                Notification.success({
                    message: "Tebrikler!",
                    description: response.description,
                    className: "general-notification",
                    placement: "bottomLeft",
                    duration: 5,
                });

                this.props.history.push(
                    `/app/trips`
                );

            })
            .catch(error => {
                loadings.submit = false;
                this.setState({ loadings });

                Notification.error({
                    message: i18n.t(`error`, {
                        lng: this.props.currentLanguage,
                    }),
                    description: errorMessageNotification(error),
                    className: "general-notification",
                    placement: "bottomLeft",
                    duration: 100,
                });

                setTimeout(() => {
                    Notification.destroy();
                }, 3000);
            })

    }


    updateOptions = () => {
        let endpoint = { keyOne: `trip`, idOne: this.props.match.params.id, keyTwo: "updateoptions" };
        this.props
            .dispatch(
                actions.definitions.getData({
                    ...endpoint
                })
            )
            .then(response => {
                this.setState({
                    updateOptions: response
                });
            });
    };

    getData = () => {

        let { loadings } = this.state;
        loadings.data = true;

        this.setState({ loadings });

        this.props.dispatch(actions.definitions.getData({
            ...this.endpoint,
            filter: this.filter
        }))
            .then(response => {

                loadings.data = false;
                this.setState({ loadings, data: response });

                try {
                    this.map.destroy();
                    this.map = null;
                } catch (e) {
                }

                this.ymap = window.ymaps;

                setTimeout(() => {
                    this.ymap.ready(this.initMap);
                }, 500);

            })
            .catch(error => {

                loadings.data = false;


                this.setState({
                    loadings, isError: true
                });

                Notification.error({
                    message: i18n.t(`warning`, {
                        lng: this.props.currentLanguage,
                    }),
                    description: errorMessageNotification(error),
                    className: "general-notification",
                    placement: "bottomLeft",
                    duration: 100,
                });

                setTimeout(() => {
                    Notification.destroy();
                }, 4000);

            })
    }

    initMap() {

        let { data } = this.state;


        var stops = data.routes
            .map(function (i) {
                return [i.latitude, i.longitude];
            })


        var coordinates = [41.045930450756735, 29.033413529100827];

        this.map = new this.ymap.Map('map-yandex', {
            center: coordinates,
            zoom: 13,
            controls: ['fullscreenControl']
        }, {
            buttonMaxWidth: 300,
            top: 100,
            left: 10
        });

        var zoomControl = new this.ymap.control.ZoomControl({
            options: {
                size: "small"
            }

        });

        this.map.controls.add(zoomControl);

        var fullscreenControl = new this.ymap.control.FullscreenControl({
            options: {
                right: 50,
                bottom: 50,
                width: 26,
                height: 25
            }

        });

        this.map.controls.add(fullscreenControl);

        var startPoint = new window.ymaps.GeoObject({
            geometry: {
                type: "Point",
                coordinates: stops[0]
            },
            properties: {
                iconContent: 'Başlangıç',
            }
        }, {
            preset: "islands#darkGreenStretchyIcon",
        });

        this.map.geoObjects.add(startPoint);

        var endPoint = new window.ymaps.GeoObject({
            geometry: {
                type: "Point",
                coordinates: stops[stops.length - 1]
            },
            properties: {
                iconContent: 'Bitiş',
            }
        }, {
            preset: "islands#redStretchyIcon"
        });

        this.map.geoObjects.add(endPoint);

        data.routes.forEach((route, index) => {

            var hintContent = "<br> ";
            hintContent += route.shortAddress;
            hintContent += "<br> ";
            hintContent += "<br> ";
            hintContent += "<br> ";
            hintContent += "<br> ";
            hintContent += "<br> ";

            var myCircle = new window.ymaps.Circle([
                [route.latitude, route.longitude],
                100
            ], {
                hintContent: hintContent
            }, {
                fillColor: "#32CD3266",
                strokeColor: "#2CAD03",
                strokeOpacity: 0.9,
                strokeWidth: 0.5
            });

            this.map.geoObjects.add(myCircle);
        })

        var viaPointActualPolylineItems = [];

        let actualRoutes = data.actualRoutes.find(x => x.source === "Vendor" && x.type === "Going");

        if (actualRoutes && actualRoutes.coordinates.length > 0) {

            viaPointActualPolylineItems = actualRoutes.coordinates
                .map(function (i) {
                    return [i.latitude, i.longitude];
                });


            var viaPointActualPolyline = new window.ymaps.Polyline(viaPointActualPolylineItems, {
                balloonContent: "Gerçekleşen Güzergah"
            }, {
                fillColor: "#32a852",
                strokeColor: "#32a852",
                strokeOpacity: 1,
                strokeWidth: 10,
                

            });

            this.map.geoObjects.add(viaPointActualPolyline);
            this.map.setBounds(viaPointActualPolyline.geometry.getBounds());

        }


        var viaPointPolylineItems = [];

        let plannedRoutes = data.actualRoutes.find(x => x.source === "GoogleMaps" && x.type === "Going").coordinates;

        viaPointPolylineItems = plannedRoutes
            .map(function (i) {
                return [i.latitude, i.longitude];
            });


        var viaPointPolyline = new window.ymaps.Polyline(viaPointPolylineItems, {
            balloonContent: "Planlanan Güzergah"
        }, {
            strokeColor: "#bb2167",
            strokeWidth: 5,
            strokeOpacity: 1,
            strokeStyle: '1 2'


        });

        this.map.geoObjects.add(viaPointPolyline);
        this.map.setBounds(viaPointPolyline.geometry.getBounds());






    }

    fetchUpdateHistory = () => {

        let endpoint = { keyOne: `trip/getdiffersfromThepreviousversion`, idOne: this.props.match.params.id };

        this.props
            .dispatch(
                actions.definitions.getData({
                    ...endpoint
                })
            )
            .then(response => {
                this.setState({ histories: response })
            });

    }

    renderUpdateHistort = () => {

        let { histories } = this.state;

        return (

            <ul>
                {
                    histories.map((item) => {
                        return (
                            <li>
                                <div className='text'>{item.text}</div>
                                <div className='date'>{moment(item.date).format("DD MMMM YYYY HH:mm")}</div>
                            </li>
                        )
                    })
                }
            </ul>
        )
    }

    gotoHomepage = () => {
        this.props.history.push(
            `/app/trips`
        )
    }

    gotoPendingTrips = () => {
        this.props.history.push(
            `/app/tripunitapprovals`
        )
    }





    render() {

        let { loadings, data, updateOptions, isError } = this.state;

        return (

            <Fragment>

                {
                    loadings.data &&
                    <div className="ant-loading loading-content">
                        <Spin
                            tip={`${i18n.t(`loading`, {
                                lng: this.props.currentLanguage,
                            })}`}
                        />
                    </div>
                }

                {
                    !loadings.data && !isError &&
                    <div className='trip-detail'>
                        <div className='page-header'>
                            <Row>
                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                    <PageHeader
                                        className="site-page-header"
                                        onBack={() =>
                                            window.history.back()
                                        }
                                        title="Geri Dön"
                                        extra={[
                                            data && data.hasPreviousVersion &&

                                            <Popover placement="bottom" title={null} content={this.renderUpdateHistort()} trigger="click" overlayClassName='trip-history-popover'>
                                                <Button
                                                    key="edit"
                                                    type='dashed'
                                                    icon={<FieldTimeOutlined />}
                                                >
                                                    Talep Geçmişini Göster
                                                </Button>
                                            </Popover>

                                            ,

                                            updateOptions && updateOptions.isUpdateable &&
                                            <Button
                                                key="edit"
                                                type='dashed'
                                                icon={<EditOutlined />}
                                                onClick={() => this.props.history.push(
                                                    `/app/trips/${this.props.match.params.id}/update`
                                                )}
                                            >
                                                Bu Talebi Düzenle
                                            </Button>,
                                            updateOptions && updateOptions.isCancelable &&
                                            <Button
                                                key="delete"
                                                type='dashed'
                                                icon={<DeleteOutlined />}
                                                onClick={() => this.showCancelConfirm()}
                                            >
                                                Bu Talebi İptal Et
                                            </Button>,
                                        ]}
                                    />
                                </Col>

                            </Row>
                        </div>
                        <div className='trip-detail-container'>

                            {
                                data.isApproverView &&
                                <TripApproverView tripId={data.id}
                                    fetchData={this.gotoPendingTrips}
                                    gotoHomepage={this.gotoHomepage}
                                    gotoPendingTrips={this.gotoPendingTrips}
                                    data={data}
                                />
                            }

                            <div className='when'>
                                <Row className='direction-container'>
                                    <Col xs={3} sm={3} md={3} lg={3} xl={3}>
                                        {
                                            data.status === "Completed" ?
                                                <CheckCircleOutlined className='anticon-green' /> :
                                                <FieldTimeOutlined />
                                        }
                                    </Col>
                                    <Col xs={9} sm={9} md={9} lg={9} xl={9}>
                                        <div className={data.status === "Completed" ? 'direction green' : 'direction'}>{data.status === "Completed" ? "GİDİŞ (TAMAMLANDI)" : "GİDİŞ (TAMAMLANMADI)"} </div>
                                        <div className='date'>{moment(data.departureDate).format('DD MMMM YYYY')}</div>
                                        <div className='hour'>{moment(data.departureDate).format('HH:mm')}</div>
                                    </Col>
                                    <Col xs={3} sm={3} md={3} lg={3} xl={3}>

                                        {
                                            data.returnDate && data.status === "Completed" ?
                                                <CheckCircleOutlined className='anticon-green' /> :
                                                <FieldTimeOutlined />
                                        }


                                    </Col>
                                    <Col xs={9} sm={9} md={9} lg={9} xl={9}>

                                        {
                                            data.returnDate ?
                                                <Fragment>
                                                    <div className='direction'>{data.status === "Completed" ? "DÖNÜŞ (TAMAMLANDI)" : "DÖNÜŞ (TAMAMLANMADI)"} </div>
                                                    <div className='date'>{moment(data.returnDate).format('DD MMMM YYYY')}</div>
                                                    <div className='hour'>{moment(data.returnDate).format('HH:mm')}</div>
                                                </Fragment>
                                                :
                                                <Skeleton
                                                    paragraph={{
                                                        rows: 2,
                                                    }}
                                                    loading
                                                />
                                        }

                                    </Col>

                                </Row>

                                <Row>
                                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>

                                        {
                                            this.props.account.mapsClient === "Yandex" ?
                                                <div id="map-yandex" className="map" style={{ width: 1250, height: 350 }} />
                                                :
                                                <Direction data={data} />
                                        }
                                    </Col>
                                </Row>

                                <Row>
                                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <Collapse
                                            defaultActiveKey={['1']}
                                            className='mr-20'
                                        >
                                            <Panel header="TALEP DETAYI" key="1">

                                                <ul>
                                                    <li>
                                                        <div className='label'>ARAÇ TİPİ</div>
                                                        <div className='text'>{data.vehicleType.name}</div>
                                                    </li>
                                                    <li>
                                                        <div className='label'>SEYAHAT TÜRÜ</div>
                                                        <div className='text'>{data.transferType.name}</div>
                                                    </li>
                                                </ul>
                                            </Panel>
                                        </Collapse>
                                        <Collapse
                                            defaultActiveKey={['1']}
                                            className='mt-20 mr-20'
                                        >
                                            <Panel header="TALEP GEÇMİŞİ" key="1">

                                                <ul>
                                                    {
                                                        data.history.map((item, index) => {
                                                            return (
                                                                <li key={index}>
                                                                    <div className='label'>{moment(item.date).format('DD MMMM YYYY HH:mm')}</div>
                                                                    <div className='text'>{item.status}</div>
                                                                    {
                                                                        item.description &&
                                                                        <div className='description'>{item.description}</div>
                                                                    }
                                                                </li>
                                                            )
                                                        })
                                                    }
                                                </ul>
                                            </Panel>
                                        </Collapse>

                                        {
                                            data.driver &&
                                            <Collapse
                                                defaultActiveKey={['1']}
                                                className='mt-20 mr-20'
                                            >
                                                <Panel header="ARAÇ BİLGİLERİ" key="1">

                                                    <ul>
                                                        <li>
                                                            <div className='label'>ŞÖFÖR</div>
                                                            <div className='text'>{data.driver.nameLastname}</div>
                                                        </li>
                                                        <li>
                                                            <div className='label'>TELEFON NUMARASI</div>
                                                            <div className='text'>{parsePhoneNumber("+" + data.driver.phoneNumber).formatInternational()}</div>
                                                        </li>
                                                        <li>
                                                            <div className='label'>PLAKA</div>
                                                            <div className='text'>{data.vehicle.plate}</div>
                                                        </li>
                                                        <li>
                                                            <div className='label'>ARAÇ</div>
                                                            <div className='text'>{data.vehicle.name}</div>
                                                        </li>
                                                    </ul>
                                                </Panel>
                                            </Collapse>
                                        }
                                    </Col>
                                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <Collapse
                                            defaultActiveKey={['1']}
                                            className='mr-20'>
                                            <Panel header="YOLCU BİLGİLERİ" key="1">
                                                {
                                                    data.passengers.map((item, index) => {
                                                        return (
                                                            <div className="passenger-info" key={index}>
                                                                <div className="pic">
                                                                    <img src="../../../assets/img/icons/empty-avatar.png" alt="" />
                                                                    <i className="fa fa-phone" ></i>
                                                                </div>
                                                                <div className="contact-info">
                                                                    <strong>{`${item.name} ${item.lastname}`}</strong>
                                                                    <span>{item.phoneNumber}</span>
                                                                    <span>{item.email}</span>
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }

                                            </Panel>
                                        </Collapse>

                                        {
                                            data.estimatedCost && data.estimatedCost.estimatedCost > 0 &&
                                            <Collapse
                                                defaultActiveKey={['1']}
                                                className='mt-20 mr-20'
                                            >
                                                <Panel header="TAHMİNİ MALİYET" key="1">
                                                    <ul>
                                                        <li>
                                                            <div className='text'>{data.estimatedCost.estimatedCost}</div>
                                                            <div className='label'>{data.estimatedCost.message}</div>
                                                        </li>
                                                    </ul>
                                                </Panel>
                                            </Collapse>
                                        }

                                    </Col>
                                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <Collapse
                                            defaultActiveKey={['1']}
                                        >
                                            <Panel header="GÜZERGAH" key="1">
                                                <ul className='routes'>

                                                    {
                                                        data.routes.map((item, index) => {
                                                            return (
                                                                <li key={index}>
                                                                    <Row>
                                                                        <Col xs={2} sm={2} md={2} lg={2} xl={2}>

                                                                            <div className="point">
                                                                                <img src="../../../assets/img/icons/location-point-gray.png" alt="" />
                                                                                <span className="order-number">{index + 1}</span>
                                                                            </div>

                                                                        </Col>
                                                                        <Col xs={22} sm={22} md={22} lg={22} xl={22}>
                                                                            <strong>{item.shortAddress}</strong>
                                                                            <span>{item.address}</span>
                                                                        </Col>
                                                                    </Row>

                                                                </li>

                                                            )
                                                        })
                                                    }



                                                </ul>
                                            </Panel>
                                        </Collapse>
                                        <Collapse
                                            defaultActiveKey={['1']}
                                            className='mt-20'
                                        >
                                            <Panel header="NOTE" key="1">
                                                <p className='note'>{data.note}</p>
                                            </Panel>
                                        </Collapse>
                                    </Col>

                                </Row>

                            </div>

                        </div>
                    </div>
                }
            </Fragment>

        );
    }
}

const mapStateToProps = ({ auth }) => ({ ...auth });
export default connect(mapStateToProps)(TripDetail);



// WEBPACK FOOTER //
// ./src/components/App/Views/Trip/TripDetail.js